import React, { useEffect, useState } from "react";
import { adminOrders, adminUpdateOrderStatus } from "../services/api";
import AdminLayout from "./AdminLayout";
import { getImageUrl } from "../utils/imageHelper";

export default function AdminOrders() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedOrder, setSelectedOrder] = useState(null);

  const fetchOrders = async () => {
    try {
      setLoading(true);
      const data = await adminOrders();
      setOrders(data);
    } catch (e) {
      console.error("Failed to load orders", e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrders();
  }, []);

  const handleStatusChange = async (id, newStatus) => {
    try {
      await adminUpdateOrderStatus(id, newStatus);
      setOrders(orders.map(o => o.id === id ? { ...o, status: newStatus } : o));
      alert("Status pesanan berhasil diperbarui");
    } catch (err) {
      alert("Gagal memperbarui status pesanan");
    }
  };

  const statusColors = {
    pending: { bg: '#FFF3E0', text: '#E65100' },
    processing: { bg: '#E3F2FD', text: '#1565C0' },
    completed: { bg: '#E8F5E9', text: '#2E7D32' },
    cancelled: { bg: '#FFEBEE', text: '#C62828' },
  };

  return (
    <AdminLayout>
      <div className="section-header" style={{ textAlign: "left", margin: "0 0 30px" }}>
        <h2 className="section-title">Riwayat Pemesanan</h2>
      </div>

      {loading ? (
        <div style={{ padding: '40px', textAlign: 'center' }}>Memuat pesanan...</div>
      ) : (
        <table className="admin-table">
          <thead>
            <tr>
              <th>ID Order</th>
              <th>Pelanggan</th>
              <th>Total Harga</th>
              <th>Status</th>
              <th>Aksi</th>
            </tr>
          </thead>
          <tbody>
            {orders.length > 0 ? orders.map((o) => (
              <tr key={o.id}>
                <td style={{ fontWeight: 700 }}>#{o.id}</td>
                <td>
                   <div style={{ fontWeight: 600 }}>{o.customer_name}</div>
                   <div style={{ fontSize: '0.8rem', color: '#666' }}>{o.phone}</div>
                </td>
                <td style={{ fontWeight: 600 }}>Rp {parseFloat(o.total_price).toLocaleString()}</td>
                <td>
                  <select 
                    value={o.status} 
                    onChange={(e) => handleStatusChange(o.id, e.target.value)}
                    style={{
                      padding: '6px 12px',
                      borderRadius: '20px',
                      fontSize: '0.8rem',
                      fontWeight: 600,
                      border: 'none',
                      cursor: 'pointer',
                      background: statusColors[o.status.toLowerCase()]?.bg || '#eee',
                      color: statusColors[o.status.toLowerCase()]?.text || '#333',
                    }}
                  >
                    <option value="pending">Pending</option>
                    <option value="processing">Processing</option>
                    <option value="completed">Completed</option>
                    <option value="cancelled">Cancelled</option>
                  </select>
                </td>
                <td>
                  <button 
                    onClick={() => setSelectedOrder(o)}
                    style={{ 
                      color: 'var(--primary)', 
                      fontWeight: 600, 
                      padding: '5px 15px', 
                      borderRadius: '8px',
                      border: '1px solid var(--primary)'
                    }}
                  >
                    Detail
                  </button>
                </td>
              </tr>
            )) : (
              <tr>
                <td colSpan="5" style={{ textAlign: 'center', padding: '40px' }}>Belum ada pesanan masuk.</td>
              </tr>
            )}
          </tbody>
        </table>
      )}

      {/* Detail Modal */}
      {selectedOrder && (
        <div style={{
          position: 'fixed',
          top: 0, left: 0, right: 0, bottom: 0,
          background: 'rgba(0,0,0,0.6)',
          zIndex: 1001,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '20px'
        }}>
          <div style={{
            background: 'white',
            width: '100%',
            maxWidth: '700px',
            borderRadius: '24px',
            padding: '40px',
            position: 'relative',
            maxHeight: '90vh',
            overflowY: 'auto'
          }}>
            <button 
              onClick={() => setSelectedOrder(null)}
              style={{ position: 'absolute', top: '20px', right: '20px', fontSize: '1.5rem', color: '#888' }}
            >
              ✕
            </button>
            <h3 style={{ marginBottom: '25px', color: 'var(--secondary)' }}>Detail Pesanan #{selectedOrder.id}</h3>
            
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '30px', marginBottom: '30px', borderBottom: '1px solid #eee', paddingBottom: '25px' }}>
              <div>
                <h5 style={{ color: '#888', marginBottom: '8px', textTransform: 'uppercase', fontSize: '0.75rem' }}>Informasi Pelanggan</h5>
                <div style={{ fontWeight: 600, fontSize: '1.1rem' }}>{selectedOrder.customer_name}</div>
                <div style={{ color: '#666' }}>{selectedOrder.phone}</div>
                <div style={{ color: '#666', marginTop: '5px' }}>{selectedOrder.address}</div>
              </div>
              <div>
                <h5 style={{ color: '#888', marginBottom: '8px', textTransform: 'uppercase', fontSize: '0.75rem' }}>Status & Tanggal</h5>
                <div style={{ marginBottom: '10px' }}>
                   <span style={{ 
                     padding: '4px 12px', 
                     background: statusColors[selectedOrder.status.toLowerCase()]?.bg, 
                     color: statusColors[selectedOrder.status.toLowerCase()]?.text,
                     borderRadius: '20px', fontWeight: 600, fontSize: '0.85rem'
                   }}>
                     {selectedOrder.status.toUpperCase()}
                   </span>
                </div>
                <div style={{ color: '#666' }}>{new Date(selectedOrder.created_at).toLocaleString('id-ID')}</div>
              </div>
            </div>

            <h5 style={{ color: '#888', marginBottom: '15px', textTransform: 'uppercase', fontSize: '0.75rem' }}>Daftar Produk</h5>
            <div style={{ marginBottom: '30px' }}>
              {selectedOrder.items?.map((item, idx) => (
                <div key={idx} style={{ display: 'flex', justifyContent: 'space-between', padding: '12px 0', borderBottom: '1px solid #f5f5f5' }}>
                  <div style={{ display: 'flex', gap: '15px' }}>
                    <div style={{ width: '50px', height: '50px', background: '#eee', borderRadius: '8px', overflow: 'hidden' }}>
                      <img 
                        src={getImageUrl(item.product?.image, 'https://via.placeholder.com/50')} 
                        alt="" 
                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                      />
                    </div>
                    <div>
                      <div style={{ fontWeight: 600 }}>{item.product?.name || 'Produk Tidak Diketahui'}</div>
                      <div style={{ fontSize: '0.85rem', color: '#888' }}>{item.qty} x Rp {parseFloat(item.price).toLocaleString()}</div>
                    </div>
                  </div>
                  <div style={{ fontWeight: 600 }}>Rp {(item.qty * item.price).toLocaleString()}</div>
                </div>
              ))}
            </div>

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '20px', background: 'var(--bg)', borderRadius: '16px' }}>
              <div style={{ fontWeight: 700, fontSize: '1.2rem' }}>Total Pembayaran</div>
              <div style={{ fontWeight: 700, fontSize: '1.5rem', color: 'var(--secondary)' }}>Rp {parseFloat(selectedOrder.total_price).toLocaleString()}</div>
            </div>
            
            <button 
              className="btn btn-primary" 
              onClick={() => setSelectedOrder(null)}
              style={{ width: '100%', marginTop: '30px' }}
            >
              Tutup Detail
            </button>
          </div>
        </div>
      )}
    </AdminLayout>
  );
}
